import Vue from 'vue';

import '@/styles/main.scss';

import App from './App';

Vue.use({});

if (process.env.NODE_ENV === 'development') {
    Vue.config.devtools = true;
    Vue.config.debug = true;
    Vue.config.productionTip = false;
}

new Vue({
    render: (h) => h(App),
}).$mount('#app');
